<template>
    <v-container pa-0 ma-0 fluid>
        <v-row no-gutters v-if="!showTimeSerresViewer">
            <v-col cols="2">
                <div v-if="!showTimeSerresViewer"
                class="text-left">
                    <v-btn
                    v-if="!showTimeSerresViewer"
                    color="primary"
                    outlined
                    small
                    class="btn_back"
                    v-on:click="closeModelSignalViewer"
                    >back to model list
                    </v-btn> 
                </div>
            </v-col>
            <v-col cols="2" >
                <span class="title">{{title}}</span>
            </v-col>
            <v-col cols="4">
                <v-radio-group style="margin-top: 5px;" height="9px" v-model="menu_options" row>
                    <v-radio label="Signals" value="signals"></v-radio>
                    <v-radio label="Scores" value="scores"></v-radio>
                    <v-radio label="Holdings" value="holdings"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <v-row v-if="!showTimeSerresViewer">
            <v-col cols="1">
                <v-row 
                    align:start
                    justify:start
                    no-gutters>
                    <v-checkbox
                        mb-0
                        v-model="selectAll" 
                        primary
                        style="margin-top: 0px;"
                        height="9px"
                        hide-details
                        @change="toggleAll($event)"
                    ></v-checkbox>
                    <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">select all</div>
                </v-row>
                <v-row 
                    align:start
                    justify:start
                    v-for="(item,key) in assetList" 
                    :key="key"  
                    no-gutters>
                    <template>
                        <v-checkbox
                            mb-0
                            v-model="selected" 
                            primary
                            style="margin-top: 0px;"
                            height="9px"
                            hide-details
                            @change="onClickCheckBox(item)"
                            :value="item.name"
                            :color="item.checkcolor"
                        ></v-checkbox>
                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{item.name}}</div>
                    </template>
                </v-row>
            </v-col>
            <v-col cols="11">
                <v-row 
                    v-if="showHeaderChart"
                    no-gutters>
                    <v-col cols="12">
                        <v-row no-gutters>
                            <v-col class="subtitle">{{chartOptionHeader.customTitle}}</v-col>
                            <v-col>
                                <v-btn color="primary"
                                outlined
                                small
                                class="timeSerieBtn" @click="goToTimeSeries(chartOptionHeader.customTitle,chartOptionHeader.timeSeriesUrl,chartOptionHeader.grouped_by)">Time Series</v-btn>
                            </v-col>
                        </v-row> 
                        <highcharts :options="chartOptionHeader"></highcharts>
                    </v-col>
                </v-row>
                <v-row
                    v-for="n in ((outputCounts/2>>0) + (outputCounts%2))"
                    :key="n"
                    :class="n === 1 ? 'mb-5' : ''"
                    no-gutters
                    >
                    <v-col
                        v-for="k in getReminder(n)"
                        :key="k"
                        cols="6"
                    >
                        <v-row no-gutters>
                            <v-col class="subtitle">{{chartOptionArray[n*2-2+k-1].customTitle}}</v-col>
                            <v-col>
                                <v-btn color="primary"
                                outlined
                                small
                                class="timeSerieBtn" @click="goToTimeSeries(chartOptionArray[n*2-2+k-1].customTitle,chartOptionArray[n*2-2+k-1].timeSeriesUrl,chartOptionArray[n*2-2+k-1].grouped_by)">Time Series</v-btn>
                            </v-col>
                        </v-row>                        
                        <highcharts :options="chartOptionArray[n*2-2+k-1]"></highcharts>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="showTimeSerresViewer">
            <TimeSeriesStock 
            v-bind:url= "timeSeriesUrlSelected"
            v-bind:title= "timeSeriesTitleSelected"
            v-bind:grouped_by= "timeSeriesGroupedBySelected"
            @close-timeSeriesViewer="onTimeSeriesViewerClose"
            />            
        </v-row>
        <v-dialog v-model="chartIsLoading" fullscreen full-width>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    class="chartIsLoading"
                    indeterminate
                    v-show="chartIsLoading"
                ></v-progress-circular>
              </v-layout>
            </v-container>
        </v-dialog>
    </v-container>    
</template>
<script>
import axios from 'axios'
import SystematicEconomics from '@/api/systematicEconomics'
import TimeSeriesStock from '@/components/TimeSeriesStock.vue'

export default {
    name: 'ModelSignalViewer',
    props: {
        modelId: {
            type: Number
        },
        title:{
            type: String,
            required: true            
        }
    },
    components:{
        TimeSeriesStock
    },
    data() {
        return {
            showHeaderChart: false,
            chartIsLoading:true,
            menu_options:'signals',
            showTimeSerresViewer:false,
            headers:[{value:'name'}],
            selected:[],
            selectAll:true,
            highlightedColor: "red",
            highlighted: [],
            assetList:[],
            assetsCountries:[],
            loading:true,
            outputCounts:0,
            modelOutputs:[],
            requestModelOutput: {
                model_id:'',
                type:'signal',
                sub_type:'regions_savg'
            },
            chartOptionArray:[],
            chartOptionHeader:null,
            chartOptions: {
                customTitle:'',
                timeSeriesUrl:'',
                grouped_by:'',
                data_original:[],
                credits: {
                    enabled: false
                },
                chart: {
                    type: 'column',
                    height:"250px",
                },
                title: {           
                    text: ''
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '9px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    gridLineDashStyle:'Dot',
                    gridLineColor:'blue',
                    gridLineWidth:1,
                    /*tickInterval: 0.5,
                    max: 2,
                    min: -2,*/
                    title: {
                        text: ''
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '<b>{point.y:.3f}</b>'
                },
                series: [{
                    name: '',
                    colorByPoint: true,
                    data: [],
                    dataLabels: {
                        enabled: false,
                        rotation: -90,
                        checkcolor: '#FFFFFF',
                        align: 'right',
                        format: '{point.y:.1f}', // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                }]
            },
            timeSeriesTitleSelected:'',
            timeSeriesUrlSelected:'',
            timeSeriesGroupedBySelected:''
        };
    },
    created(){
        this.getModelOutputs()
    },    
    watch: {
        menu_options: function (val) {
            switch(val){
                case "scores":
                    this.requestModelOutput.type = 'score'
                    this.chartIsLoading=true
                    this.showHeaderChart = false
                    this.getModelOutputs()
                break;
                case "signals":
                    this.requestModelOutput.type = 'signal'
                    this.chartIsLoading=true
                    this.showHeaderChart = false
                    this.getModelOutputs()
                break;
                case "holdings":
                    this.requestModelOutput.type = 'holdings'
                    this.chartIsLoading=true
                    this.showHeaderChart = false
                    this.getModelOutputs()
                break;
            }
        }
    },
    methods:{ 
        closeModelSignalViewer(){
            this.$emit('close-modelSignalViewer','true');
        },
        getModels () {
            const vm = this 
            return new Promise((resolve, reject) => {
            SystematicEconomics.getModels(this.userId).then(
                data => {
                vm.models = _.orderBy(data, ['name'], ['asc']);
                
                if(_.size(vm.models)==0){
                    vm.empty=true
                }
                else{
                    vm.empty=false
                }
                }
            )
            })
        },
        getModelOutputs () {
            const vm = this 
            return new Promise((resolve, reject) => {
                this.requestModelOutput.model_id = vm.modelId
                SystematicEconomics.getModelOutputs(this.requestModelOutput).then(
                    data => {
                        vm.modelOutputs = _.cloneDeep(data)
                        vm.outputCounts = _.size(vm.modelOutputs)
                        vm.assetList = _.orderBy(data[0].preview.assetColumns, 'assetOrder')
                        vm.assetsCountries =  _.cloneDeep(vm.assetList)   
                        vm.selected = _.map(vm.assetList, 'name')
                        vm.chartOptionArray = []

                        _.forEach(vm.modelOutputs, function(output) {
                            var opt = _.cloneDeep(vm.chartOptions)
                            switch(vm.menu_options){
                                case "scores":
                                    opt.yAxis.tickInterval= 0.5
                                    opt.yAxis.max= 2
                                    opt.yAxis.min= -2
                                break;
                                case "signals":
                                    opt.yAxis.tickInterval= 0.5
                                    if(output.preview.name.includes('carry')){
                                        opt.yAxis.max= null
                                        opt.yAxis.min= null
                                    }else{
                                        opt.yAxis.max= 2
                                        opt.yAxis.min= -2                                        
                                    }
                                break;
                                case "holdings":
                                    opt.yAxis.tickInterval= 0.1
                                    opt.yAxis.max= null
                                    opt.yAxis.min= null
                                break;
                            }
                            opt.series[0].data = _.orderBy(output.preview.assetColumns, 'y','desc')
                            opt.data_original = _.cloneDeep(opt.series[0].data)
                            opt.customTitle = output.preview.name
                            opt.grouped_by = output.grouped_by
                            opt.timeSeriesUrl = output.time_serie
                            if(output.title.includes('weighted')||vm.menu_options=='holdings'){
                                opt.chart.height = "450px"
                                vm.chartOptionHeader = opt
                                vm.showHeaderChart = true
                                vm.outputCounts = vm.outputCounts -1
                            }
                            else{
                                vm.chartOptionArray.push(opt)
                            }                            
                        });
                        vm.chartIsLoading=false
                    }                    
                )                
            })
        },
        goToTimeSeries(signalName,timeSeriesUrl,grouped_by){
            this.showTimeSerresViewer = true
            this.timeSeriesUrlSelected = timeSeriesUrl
            this.timeSeriesTitleSelected = signalName + '_' + this.requestModelOutput.type
            this.timeSeriesGroupedBySelected = grouped_by
        },
        getReminder(n){
            if(this.outputCounts<n*2)
                return 1
            else
                return 2
        },
        onClickCheckBox(props){
            const vm = this 
            if(_.findIndex(this.selected, function(o) { return o == props.name; })<0)
            {
                if(props.checkcolor !=this.highlightedColor)
                {
                    this.selected.push(props.name);
                    this.highlighted.push(props.name);
                    props.checkcolor=this.highlightedColor;                    
                    _.forEach(vm.chartOptionArray, function(output) {
                        vm.setBorderColor(output.series[0].data ,props.name,vm.highlightedColor);
                    });
                }
                else{
                    _.remove(this.highlighted, function(o) { return o == props.name; });
                    props.checkcolor = props.color;
                    this.deleteItem(props);
                }
            }
            else{
                this.selected.push(props.name);
                this.addItem(props);
                props.checkcolor = props.color;
                
            }
        },
        toggleAll(event) {
            if (event){
                this.selected = _.map(this.assetList, 'name');
                var aux = _.cloneDeep(this.assetList);
                 _.forEach(this.highlighted, function(item) {
                    _.remove(aux, function(o) { return o.name == item; });
                 });
                this.addItems(aux);
            }
            else
            {
                this.selected = _.cloneDeep(this.highlighted);
                var aux = _.cloneDeep(this.assetList);
                 _.forEach(this.selected, function(item) {
                    _.remove(aux, function(o) { return o.name == item; });
                 });
                this.deleteItems(aux);
            }            
        },
        addItems(items){
            var me = this;
            _.forEach(items, function(item) {
                me.addItem(item);
            });
        },
        addItem(item){
            const vm = this
            _.forEach(vm.chartOptionArray, function(output) {
                var aux = _.find(output.series[0].data, function(o) { return o.name == item.name; });
                if(aux != null)
                {
                    aux.y = _.find(output.data_original, function(o) { return o.name == item.name; }).y
                    aux.borderColor = _.find(output.data_original, function(o) { return o.name == item.name; }).color
                }
            });
            _.find(this.assetList, function(o) { return o.name == item.name; }).isSelected = 1;
        },
        deleteItems(items){
            var me = this;
            _.forEach(items, function(item) {
                me.deleteItem(item);
            });
        },
        findAndReplaceY(list, keySearch, newValue){
            var obj = _.find(list, function(o) { return o.name == keySearch; });
            if(obj != null)
            {
                obj.y = newValue;
            }
        },
        deleteItem(item){
            const vm = this
            _.forEach(vm.chartOptionArray, function(output) {
                vm.findAndReplaceY(output.series[0].data ,item.name,0);
            });
            _.find(this.assetList, function(o) { return o.name == item.name; }).isSelected = 0;
        },
        setBorderColor(list, keySearch, newBorderColor){
            var obj =_.find(list, function(o) { return o.name == keySearch; });
            if(obj != null)
                obj.borderColor = newBorderColor;
        },
        onTimeSeriesViewerClose(){
            this.showTimeSerresViewer = false
        }
    }
}
</script>
<style scoped>
    .cell_left_pad{        
        padding-left: 0px;
    }
    .title{
        font-size: 22px !important;
        font-weight: 400;      
    }
    .subtitle{
        font-size: medium !important;        
    }
    .timeSerieBtn{
        font-size: xx-small !important;
    }
</style>